import React from 'react';
import { Link } from 'react-router-dom';

class Footer extends React.Component {
	
	render() {
		return (
			<div className="footer container">

				<div className="row">
					<div className="col-md-6">
						<Link className='footer-link' to='/page/about'>About</Link>
						<Link className='footer-link' to='/page/privacy'>Privacy</Link>
					</div>
					<div className="col-md-6 text-right">
						<a href="https://www.distortion.co.uk/" className='footer-link' style={{margin: 0}}>App Development</a> by 
						<a href="https://www.distortion.co.uk/?org=mymhp&utm_source=referral&utm_medium=web&utm_campaign=footerlink&utm_referrer=https://www.mymhp.org.uk/" className='footer-link' style={{marginLeft:4}}>Distortion</a>
					</div>
				</div>
			</div>
		);
	}
}




export default Footer;



// WEBPACK FOOTER //
// ./src/js/components/Footer/Footer.js